import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AppointmentBooking } from "./components/AppointmentBooking";
import { ConfirmationPage } from "./components/ConfirmationPage";
import { CancellationPage } from "./components/CancellationPage";
import { AdminPanel } from "./components/AdminPanel";

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <div className="min-h-screen bg-background">
          <header className="bg-[#f8f7f2] border-b border-[#e6e3da] shadow-sm">
            <div className="max-w-6xl mx-auto px-4 py-4 flex flex-col items-center gap-2 text-center sm:flex-row sm:justify-center sm:gap-4 sm:text-left">
              <a href="/" className="shrink-0" aria-label="Ιατρείο Ενδοκρινολογίας — Αρχική">
                <img
                  src="/toulis-atoms-green.svg"
                  alt="Ιατρείο Ενδοκρινολογίας Dr. Κωνσταντίνου Α. Τουλή"
                  className="h-12 md:h-14 w-auto"
                />
              </a>
              <div>
                <h1 className="text-lg md:text-xl font-semibold text-[#3a4a62] tracking-tight leading-snug">
                  Ιατρείο Ενδοκρινολογίας, Σακχαρώδη Διαβήτη & Μεταβολισμού
                </h1>
                <p className="text-sm text-foreground/60 mt-1">
                  Μητροπόλεως 73, Θεσσαλονίκη · 2ος όροφος
                </p>
              </div>
            </div>
          </header>
          <main className="py-8">
            <Routes>
              <Route path="/" element={<AppointmentBooking />} />
              <Route path="/confirm/:token" element={<ConfirmationPage />} />
              <Route path="/cancel/:token" element={<CancellationPage />} />
              <Route path="/admin" element={<AdminPanel />} />
            </Routes>
          </main>
          <footer className="bg-card border-t mt-auto">
            <div className="max-w-6xl mx-auto px-4 py-4 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-foreground/70">
              <span>
                © 2026 Ιδιωτικό Ιατρείο Dr Κωνσταντίνου Α. Τουλή. Όλα τα
                δικαιώματα κατοχυρωμένα.
              </span>
              <div className="flex items-center gap-2">
                <img
                  src="/pyruvate-logo.png"
                  alt="pyruvate.dev"
                  className="h-6 w-auto"
                />
                <span>pyruvate.dev 2026</span>
              </div>
            </div>
          </footer>
        </div>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
